import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconGridSquarePlus: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2923 14.1673C17.2923 14.5123 17.0123 14.7923 16.6673 14.7923H14.7923V16.6673C14.7923 17.0123 14.5123 17.2923 14.1673 17.2923C13.8223 17.2923 13.5423 17.0123 13.5423 16.6673V14.7923H11.6673C11.3223 14.7923 11.0423 14.5123 11.0423 14.1673C11.0423 13.8223 11.3223 13.5423 11.6673 13.5423H13.5423V11.6673C13.5423 11.3223 13.8223 11.0423 14.1673 11.0423C14.5123 11.0423 14.7923 11.3223 14.7923 11.6673V13.5423H16.6673C17.0123 13.5423 17.2923 13.8223 17.2923 14.1673ZM17.2923 4.58398V7.08398C17.2923 8.25815 16.5915 8.95898 15.4173 8.95898H12.9173C11.7432 8.95898 11.0423 8.25815 11.0423 7.08398V4.58398C11.0423 3.40982 11.7432 2.70898 12.9173 2.70898H15.4173C16.5915 2.70898 17.2923 3.40982 17.2923 4.58398ZM16.0423 4.58398C16.0423 4.09315 15.9082 3.95898 15.4173 3.95898H12.9173C12.4265 3.95898 12.2923 4.09315 12.2923 4.58398V7.08398C12.2923 7.57482 12.4265 7.70898 12.9173 7.70898H15.4173C15.9082 7.70898 16.0423 7.57482 16.0423 7.08398V4.58398ZM8.95898 4.58398V7.08398C8.95898 8.25815 8.25815 8.95898 7.08398 8.95898H4.58398C3.40982 8.95898 2.70898 8.25815 2.70898 7.08398V4.58398C2.70898 3.40982 3.40982 2.70898 4.58398 2.70898H7.08398C8.25815 2.70898 8.95898 3.40982 8.95898 4.58398ZM7.70898 4.58398C7.70898 4.09315 7.57482 3.95898 7.08398 3.95898H4.58398C4.09315 3.95898 3.95898 4.09315 3.95898 4.58398V7.08398C3.95898 7.57482 4.09315 7.70898 4.58398 7.70898H7.08398C7.57482 7.70898 7.70898 7.57482 7.70898 7.08398V4.58398ZM8.95898 12.9173V15.4173C8.95898 16.5915 8.25815 17.2923 7.08398 17.2923H4.58398C3.40982 17.2923 2.70898 16.5915 2.70898 15.4173V12.9173C2.70898 11.7432 3.40982 11.0423 4.58398 11.0423H7.08398C8.25815 11.0423 8.95898 11.7432 8.95898 12.9173ZM7.70898 12.9173C7.70898 12.4265 7.57482 12.2923 7.08398 12.2923H4.58398C4.09315 12.2923 3.95898 12.4265 3.95898 12.9173V15.4173C3.95898 15.9082 4.09315 16.0423 4.58398 16.0423H7.08398C7.57482 16.0423 7.70898 15.9082 7.70898 15.4173V12.9173Z"
      fill={color}
    />
  </svg>
);

export default IconGridSquarePlus;
